export const ModuleColor = (application) => {
  switch (application) {
    case "Trak Learning":
    case "TL":
      return "orange";

    case "Trak Coaching":
    case "TC":
      return "blue";

    case "DelegateHR":
    case "DHR":
      return "green";

    case "TraineryLMS":
    case "LMS":
      return "purple";

    case "Review Cloud":
    case "RC":
      return "cyan";

    case "TNMIS":
      return "yellow";

    case "CompBldr":
    case "CBR":
    case "JobBldr":
    case "JBR":
    case "JA/MP":
    case "JAMP":
    case "JB":
    case "CMP":
    case "Comp Project":
      return "red";

    case "GRADEBldr":
    case "GB":
      return "yellow";

    default:
      return "cyan";
  }
};
export const UserTypeColor = (application) => {
  switch (application) {
    case "admin":
      return "gold";
    case "trainer":
      return "purple";
    case "attendee":
      return "geekblue";
    default:
      return "blue";
  }
};
export const RecipientsColor = (application) => {
  switch (application) {
    case "attendees":
      return "gold";
    case "trainers":
      return "purple";
    case "coachee":
      return "geekblue";
    case "coach":
      return "blue";
    default:
      return "black";
  }
};
export const ModuleTagName = (application) => {
  switch (application) {
    case "Trak Learning":
      return "TL";
    case "Trak Coaching":
      return "TC";
    case "DelegateHR":
      return "DHR";
    case "TraineryLMS":
      return "LMS";
    case "Review Cloud":
      return "RC";
    case "CompBldr":
      return "CBR";
    case "TNMIS":
      return "TNMIS";
    case "JobBldr":
      return "JBR";
    case "JA/MP":
    case "JAMP":
      return "JA/MP";
    case "Comp Project":
      return "CMP";
    default:
      return application?.substring(0, 3)?.toUpperCase();
  }
};
const shortToFullMap = {
  TL: "Trak Learning",
  TC: "Trak Coaching",
  DHR: "DelegateHR",
  LMS: "TraineryLMS",
  RC: "Review Cloud",
  CBR: "CompBldr",
  CB: "CompBldr",
  TCR: "Trak Credentails",
  TNMIS: "TNMIS",
  JB: "JobBldr",
  JAMP: "JA/MP",
  CP: "Comp Project",
  GRADEB: "GRADEBldr",
  TraineryOne: "T1",
};
export const getFullApplicationName = (shortForm) => {
  return shortToFullMap[shortForm] || shortForm; // Return the shortForm if not found
};
export const remainingViewportHeight = (otherElementsHeight) => {
  const remToPixels = 10;
  const otherElementsHeightInPixels = otherElementsHeight * remToPixels;
  const windowHeight = window.innerHeight;
  const remainingViewportHeight = windowHeight - otherElementsHeightInPixels;
  return remainingViewportHeight;
};
export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
export const allowedRoles = [
  "client_admin",
  "level1_manager",
  "level2_manager",
  "level3_manager",
];
export const ClientTypeDropDown = ["Insurance", "Other"];

export const commonPasswords = [
  // "123456",
  // "123456789",
  // "12345",
  "qwerty",
  "password",
  "12345678",
  "111111",
  "123123",
  "1234567890",
  "1234567",
  "qwerty123",
  "000000",
  "1q2w3e",
  "aa12345678",
  "abc123",
  "xyz123",
  "password1",
  "qwertyuiop",
  "123321",
  // "1234",
  "password123",
];
export const truncateText = (text, maxLength = 10) => {
  if (text?.length <= maxLength) return text;
  return text?.slice(0, maxLength) + "...";
};
export const capitalizeWords = (words) => {
  const specialWords = ["api", "id", "ip"];
  return words
    ?.split(" ")
    ?.map((word) => {
      if (word.startsWith("(") && word.endsWith(")")) {
        return word;
      }
      const lowerCaseWord = word.toLowerCase();
      if (specialWords.includes(lowerCaseWord)) {
        return lowerCaseWord.toUpperCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    ?.join(" ");
};
export const NewAddIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="34" height="34" rx="6" fill="#4B8BD1" />
    <path
      d="M17 8.5V25.5"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.5 17H25.5"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const NewUploadIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="34" height="34" rx="6" fill="#255D9B" />
    <path
      d="M9 22V24C9 24.5304 9.21071 25.0391 9.58579 25.4142C9.96086 25.7893 10.4696 26 11 26H23C23.5304 26 24.0391 25.7893 24.4142 25.4142C24.7893 25.0391 25 24.5304 25 24V22"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 14L17 9L22 14"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17 9V21"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const NewSearchIcon = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6781 13.5026C15.8884 11.8008 16.4305 9.69075 16.1959 7.59471C15.9613 5.49868 14.9673 3.57121 13.4128 2.19792C11.8583 0.82463 9.85794 0.106798 7.81187 0.188037C5.76581 0.269276 3.82496 1.14359 2.37762 2.63607C0.930277 4.12855 0.0831823 6.12912 0.00580795 8.23754C-0.0715664 10.346 0.626485 12.4067 1.96031 14.0076C3.29413 15.6084 5.16536 16.6313 7.19963 16.8715C9.23389 17.1118 11.2812 16.5517 12.9319 15.3033H12.9306C12.9681 15.3548 13.0081 15.4037 13.0531 15.4514L17.8654 20.4102C18.0998 20.6519 18.4178 20.7878 18.7493 20.7879C19.0809 20.788 19.399 20.6524 19.6335 20.4109C19.8681 20.1694 19.9999 19.8417 20 19.5001C20.0001 19.1584 19.8685 18.8307 19.6341 18.589L14.8218 13.6301C14.7771 13.5835 14.7291 13.5405 14.6781 13.5013V13.5026ZM15.0006 8.55151C15.0006 9.48181 14.8227 10.403 14.4773 11.2625C14.1318 12.1219 13.6254 12.9029 12.987 13.5607C12.3486 14.2185 11.5907 14.7403 10.7567 15.0963C9.92258 15.4523 9.02862 15.6356 8.12582 15.6356C7.22301 15.6356 6.32905 15.4523 5.49497 15.0963C4.66089 14.7403 3.90302 14.2185 3.26464 13.5607C2.62626 12.9029 2.11987 12.1219 1.77438 11.2625C1.4289 10.403 1.25108 9.48181 1.25108 8.55151C1.25108 6.6727 1.97538 4.87084 3.26464 3.54232C4.55391 2.2138 6.30252 1.46745 8.12582 1.46745C9.94911 1.46745 11.6977 2.2138 12.987 3.54232C14.2763 4.87084 15.0006 6.6727 15.0006 8.55151Z"
      fill="#255D9B"
    />
  </svg>
);

export const NewFilterIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="34" height="34" rx="6" fill="#4B8BD1" />
    <path
      d="M10.1666 9.66667H24.8333V11.6577C24.8332 12.1439 24.64 12.6101 24.2961 12.9538L20.25 17V23.4167L14.75 25.25V17.4583L10.6433 12.941C10.3366 12.6036 10.1667 12.164 10.1666 11.7081V9.66667Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const NewRefreshIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="34" height="34" rx="6" fill="#255D9B" />
    <path
      d="M23.7875 18.9167C23.5557 20.6851 22.6873 22.3085 21.3448 23.4829C20.0024 24.6573 18.278 25.3022 16.4944 25.2969C14.7108 25.2915 12.9903 24.6363 11.6549 23.454C10.3195 22.2716 9.46086 20.643 9.23963 18.8732C9.0184 17.1033 9.44978 15.3135 10.453 13.8388C11.4562 12.3641 12.9625 11.3055 14.69 10.8613C16.4174 10.4171 18.2475 10.6177 19.8377 11.4255C21.4279 12.2333 22.6691 13.593 23.3291 15.25M23.7875 11.5833V15.25H20.1208"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const transformCategoriesToTreeData = (categories) =>
  categories.map((category) => ({
    title: category.name,
    value: category.id,
    key: category.id,
    children:
      category.second_categories?.map((second) => ({
        title: second.name,
        value: second.id,
        key: second.id,
        children:
          second.third_categories?.map((third) => ({
            title: third.name,
            value: third.id,
            key: third.id,
          })) || [],
      })) || [],
  }));

export const convertCategoriesToTreeNodes = (categories, searchText = "") => {
  const matches = (text) =>
    text.toLowerCase().includes(searchText.toLowerCase());

  const processChildren = (children) => {
    return children
      .map((child) => {
        const nestedChildren = child.third_categories
          ?.map((third) => ({
            title: third.name,
            key: `third-${third.id}`,
            isLeaf: true,
            count: third.count,
          }))
          .filter((child) => matches(child.title));

        if (matches(child.name) || nestedChildren.length) {
          return {
            title: child.name,
            key: `sub-${child.id}`,
            children: nestedChildren,
            count: child.count,
          };
        }
        return null;
      })
      .filter(Boolean);
  };

  return categories
    .map((category) => {
      const secondChildren = processChildren(category.second_categories || []);

      if (
        (matches(category.name) || secondChildren.length) &&
        category.count > 0
      ) {
        return {
          title: category.name,
          key: `cat-${category.id}`,
          children: secondChildren,
          count: category.count,
        };
      }
      return null;
    })
    .filter(Boolean);
};

export const formatDateWithSuffix = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (isNaN(date)) return "";

  // const month = date.toLocaleString("default", { month: "short" });
  // const day = date.getDate();
  // const year = date.getFullYear();
  // Use UTC methods to avoid timezone conversion issues
  // This ensures dates display the same regardless of user's timezone
  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  const month = monthNames[date.getUTCMonth()];
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();

  // const getDaySuffix = (day) => {
  //   if (day > 3 && day < 21) return "th";
  //   switch (day % 10) {
  //     case 1:
  //       return "st";
  //     case 2:
  //       return "nd";
  //     case 3:
  //       return "rd";
  //     default:
  //       return "th";
  //   }
  // };

  // const suffix = getDaySuffix(day);
  //return `${day}${suffix} ${month} ${year}`;
  return `${month}-${day < 10 ? "0" + day : day}-${year}`;

};
export const getDisplayNameFiles = (filename) => {
  const lastDotIndex = filename.lastIndexOf(".");
  if (lastDotIndex === -1) return filename; // No extension, return as is

  const baseName = filename.substring(0, lastDotIndex);
  const extension = filename.substring(lastDotIndex);

  const trailingDigitsMatch = baseName.match(/(\d+)$/);
  if (trailingDigitsMatch) {
    const digitsLength = trailingDigitsMatch[1].length;
    const cleanedBase = baseName.slice(0, -digitsLength);
    return cleanedBase + extension;
  }

  return filename; // No trailing digits, return original
};
